import React from 'react';
import './App.css';
import { AppRoutes } from './route/app.route';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Main: React.FC = () => {
  return (
    <ThemeProvider>
      <>
        <AppRoutes />
        <ToastContainer />
      </>
    </ThemeProvider>
  );
};

export default Main;
